import styled, { css } from "styled-components";
import { Colors } from "../config";
import { Wrapper, Error } from "../config/StyledComponents";
import InputLabel from "../components/InputLabel";

const InputField = ({
  type,
  label,
  required,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
  disabled,
  onChange,
  placeholder,
  value,
  name,
  maxLength,
  helperText,
  isRounded,
  width,
  leftImg,
  onFocus,
  onBlur,
  onKeyDown
}) => {
  return (
    <Wrapper>
      <InputLabel
        label={label}
        isRounded={isRounded}
        labelFontColor={labelFontColor}
        labelFontSize={labelFontSize}
        labelFontWeight={labelFontWeight}
        required={required}
      />
      <LeftImg src={leftImg} helperText={helperText} />
      <TextField
        type={type || "text"}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        name={name}
        autoComplete="off"
        maxLength={maxLength}
        helperText={helperText}
        isRounded={isRounded}
        width={width}
        leftImg={leftImg}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      {helperText && <Error isRounded={isRounded}>{helperText}</Error>}
    </Wrapper>
  );
};

const LeftImg = styled.img`
  width: 1.5rem;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  ${(props) =>
    props.helperText &&
    css`
      bottom: 2rem;
    `}
`;
const TextField = styled.input`
  font-style: normal;
  width: ${(props) =>
    props.width
      ? props.width
      : props.leftImg
      ? "calc(100% - 4.5rem)"
      : "calc(100% - 3rem)"};
  background: ${(props) =>
    props.isRounded ? "none" : Colors.brandFiveOpacity40};
  color: ${(props) =>
    props.value && props.disabled
      ? Colors.sharkOpacity30
      : props.disabled
      ? Colors.sharkOpacity10
      : Colors.shark};
  cursor: ${(props) => (props.disabled ? "no-drop" : "default")};
  font-size: 1rem;
  font-weight: 600;
  padding: ${(props) => (props.isRounded ? "1rem 1.5rem" : "0.844rem 0.75rem")};
  padding-left: ${(props) =>
    props.leftImg ? "3rem" : props.isRounded ? "1.5rem" : "0.75rem"};
  border-radius: ${(props) => (props.isRounded ? "2.5rem" : "0.625rem")};
  border: ${(props) =>
    props.helperText
      ? `1px solid ${Colors.red}`
      : props.isRounded
      ? `1px solid ${Colors.coolGrey}`
      : "none"};
  ::placeholder {
    color: ${(props) =>
      props.isRounded ? Colors.sharkOpacity20 : Colors.sharkOpacity30};
    font-weight: 600;
  }
`;

export default InputField;
